import React, {useCallback, useRef, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';

import {smartEngageSelector} from '@ibibo/hotels-smartengage-store';

import SmartEngageUI from '../../../../stories/components/hotels/SRP/SmartEngageUI/SmartEngageUI';

const SmartEngageBanner = ({page,selector}) => {
  const {isLoading: isApiLoading, dataList: smartEngageDataList, dataObject: smartEngageDataObject } = useSelector(smartEngageSelector);
  let value = []
  const BannerSlicePicker = ()   =>{
    // The banner at the top and the middle are the 2 selectors we have.
    // They're accordingly read from the redux
    // We can control presence/absence/flipping of the banners using voyager
    // whatsapp smart engage in the bottom always listens to srp2, offer smart engage at the top listens to srp3
    // they're skipped if we don't get data from voyager
    if (selector === 0) {
        value =  smartEngageDataObject.listOfHomeImages || []
        return
    }

    value =  selector === 1 ? smartEngageDataObject.additionalBannerImages || [] : smartEngageDataObject.listOfImages || []

}

  BannerSlicePicker()
  const smartEngageDataRef = useRef(value)
  const isApiLoadingRef = useRef(isApiLoading);

  useEffect(() => {
    BannerSlicePicker()
    smartEngageDataRef.current = value
    isApiLoadingRef.current = isApiLoading;
  }, [smartEngageDataList, isApiLoading, smartEngageDataObject]);

  const thereIsSmartEngageList = smartEngageDataRef.current && smartEngageDataRef.current.length;

  return (
    <div>
      <SmartEngageBannerWrap>
        {(isApiLoading && null) ||
          (thereIsSmartEngageList && (
            <SmartEngageUI dataList={smartEngageDataRef.current} />
          )) ||
          null}
      </SmartEngageBannerWrap>
    </div>
  );
};

export default SmartEngageBanner;

const SmartEngageBannerWrap = styled.div(
  props => `
  position:relative;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  `,
);
